export default __webpack_public_path__ + "static/media/template8.be9cd7f4.svg";